import PropTypes from 'prop-types';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})(({ theme, isChecked }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: '1rem',
  marginLeft: '0px',
  marginBottom: '0.5rem',
  padding: '0.5rem 1rem',
  ...(isChecked && {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  }),
}));

const CheckboxGroupComponent = (props) => {
  const {
    input,
    label,
    meta: { touched, error },
    options,
    row,
    ...custom
  } = props;
  const hasError = touched && !!error;
  const { name, onChange, value: inputValue = [] } = input;
  return (
    <FormControl error={hasError} {...custom}>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup row={row}>
        {options.map(({ label, value }, index) => {
          const handleChange = (event) => {
            const values = [...inputValue];
            if (event.target.checked) {
              values.push(value);
            } else {
              values.splice(values.indexOf(value), 1);
            }
            return onChange(values);
          };
          const checked = inputValue.includes(value);
          return (
            <div key={`checkbox-${value}`}>
              <StyledFormControlLabel
                isChecked={checked}
                control={
                  <Checkbox
                    checked={checked}
                    color="primary"
                    size="medium"
                    sx={{ display: 'none' }}
                    name={`${name}[${index}]`}
                    value={value}
                    onChange={handleChange}
                    checkedIcon={<span />}
                    icon={<span />}
                  />
                }
                label={label}
              />
            </div>
          );
        })}
        {hasError && <FormHelperText variant="filled">{error}</FormHelperText>}
      </FormGroup>
    </FormControl>
  );
};

CheckboxGroupComponent.defaultProps = {
  label: null,
  row: true,
  options: [],
  input: {},
  meta: {},
};

CheckboxGroupComponent.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  row: PropTypes.bool,
  options: PropTypes.instanceOf(Array),
  input: PropTypes.instanceOf(Object),
  meta: PropTypes.instanceOf(Object),
};

export default CheckboxGroupComponent;
